import * as _4 from 'lodash4';
import { AccountIdentityDatastore } from '../datastore/account_identity_datastore';
import { MemberConfigurationDatastore } from '../datastore/member_configuration_datastore';
export class UserActivityActivationQuery {
  private _QUERY_DEFAULT = {
    about: {},
    personRegistration: {
      properties: {}
    }
  };
  private query: any;
  constructor(
    private Configuration: any,
    private ngAccountIdentityDatastore: AccountIdentityDatastore,
    private ngMemberConfigurationDatastore: MemberConfigurationDatastore
  ) {
    this.query = _4.clone(this._QUERY_DEFAULT);
  }

  get result() {
    return this.query;
  }

  run() {
    const tracking = this.Configuration.read('tracking');
    this.query = _4.clone(this._QUERY_DEFAULT);

    if (!tracking) {
      return this.query;
    }

    this.query.about = this.Configuration.read('about');
    this.query.about.member = this.ngMemberConfigurationDatastore.read((store: any) => store.inst_name);

    this.query.personRegistration = {
      id: this.ngAccountIdentityDatastore.read((store) => store.tracking_id),
      email: this.ngAccountIdentityDatastore.read((store) => store.email),
      properties: {}
    };

    return this.query;
  }
}
angular
  .module('data-ng-authentication')
  .factory(
    'ngUserActivityActivationQuery',
    (
      Configuration: any,
      ngAccountIdentityDatastore: AccountIdentityDatastore,
      ngMemberConfigurationDatastore: MemberConfigurationDatastore
    ) => new UserActivityActivationQuery(Configuration, ngAccountIdentityDatastore, ngMemberConfigurationDatastore)
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/queries/user_activity_activation_query.ts